import React from "react";
import { Box, Button, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  editorRow: {
    padding: theme.spacing(1, 2),
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

// The text editor itself - always expanded, shown/hidden by the parent
// (coordinated with AddSongControl so only one "add" editor is open per
// section at a time). The plain-text sibling of AddSongControl - for a
// section item that isn't a real catalog song. What's typed here is
// exactly what's stored and exactly what lands in the WhatsApp export -
// deliberately no rich-text controls, since WhatsApp itself doesn't have
// any to target.
export default ({ onAdd, onCancel }) => {
  const classes = useStyles();
  const [text, setText] = React.useState("");

  const handleAdd = () => {
    if (!text.trim()) return;
    onAdd(text);
  };

  return (
    <Box className={classes.editorRow}>
      <TextField
        multiline
        fullWidth
        minRows={3}
        variant="outlined"
        color="secondary"
        placeholder={"*Worship Set*\n- Song one\n- Song two"}
        value={text}
        onChange={(event) => setText(event.target.value)}
        autoFocus
      />
      <Box className={classes.actions}>
        <Button size="small" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="small" color="secondary" onClick={handleAdd} disabled={!text.trim()}>
          Add
        </Button>
      </Box>
    </Box>
  );
};
